// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xCa9","col":"styles_col__4aj-e"};